import './location.scss';

import { Outlet } from "react-router-dom";

import { FilterLocationProvider } from "./filter-location/filter-location.context";

export function Location() {
  return (
    <div id="ShellLocation" className="location">
       <FilterLocationProvider>
        <Outlet />
      </FilterLocationProvider>
    </div>
  );
}

export default Location;
